import {makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { ArticleDeliveryService } from "../../../service/articleDelivery/ArticleDeliveryService";

class ConfirmArticleOrderReceivedStore {

    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;
    public deliveryPersonId: string;
    public articleDeliveryId: string;

    constructor(commonStore: CommonStore, deliveryPersonId: string, articleDeliveryId: string) {
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        this.deliveryPersonId = deliveryPersonId;
        this.articleDeliveryId = articleDeliveryId;
        makeAutoObservable(this);
    }

    public async confirmReceived() {
        this.loading = true;
        const response = await ArticleDeliveryService.confirmReceived(this.deliveryPersonId, this.articleDeliveryId);
        if (response.success && response.data) {
            return response.data;
        }
        this.loading = false;
        return null;
    }
}

export default ConfirmArticleOrderReceivedStore;